var render = function render(){var _vm=this,_c=_vm._self._c;return _c('riseup-button',{staticClass:"radio-riseup-button ri-body",class:{ 'with-border': !_vm.isSelected },attrs:{"action":_vm.select,"title":"","bold":false,"color":_vm.isSelected ? 'blue' : 'black',"variant":_vm.isSelected ? 'primary' : 'secondary'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }